import { request } from './request'

/**
 * 获取首页新闻列表
 * @param {Array} categoryIdList - 分类 ID 列表
 * @returns {Promise<Array>} 新闻列表
 */
export async function fetchHomeNewsList(categoryIdList) {
  const res = await request.post('/api/index/getNewsList', {
    categoryIdList
  })
  const data = res.data || []
  return Array.isArray(data) ? data : (data.list || data.rows || [])
}

/**
 * 获取站点配置内容
 * @param {string} configKey - 配置键名
 * @returns {Promise<string>} 配置内容（configValue）
 */
export async function fetchSiteConfig(configKey) {
  const res = await request.get('/api/index/getSiteConfig', { params: { configKey } })
  return (res.data && res.data.configValue) || ''
}
